import { lazy } from "react";
import Icon from "@mui/material/Icon";
import { prefetchFormDetails } from "utils/prefetchFormDetails";

const Bulk = lazy(() => import("layouts/bulkupload/index"));
const AccessDenied = lazy(() => import("layouts/authentication/access-denied"));
const Logout = lazy(() => import("layouts/logout"));
const Tables = lazy(() => import(/* webpackPrefetch: true */ "layouts/tables"));
const WorkflowUpdate = lazy(() => import("layouts/workflowUpdate/workflowUpdate"));
const UserManagement = lazy(() => import("layouts/admin/userManagement"));
const FormDetails = lazy(() => prefetchFormDetails());
const Analytics = lazy(() => import(/* webpackPrefetch: true */ "layouts/analytics/Analytics"));
const Profile = lazy(() => import("layouts/profile/Profile"));
const WorkflowView = lazy(() => import("layouts/workflowView/WorkflowView"));
const TagInsights = lazy(() => import("layouts/taginsights"));
const CaseClassification = lazy(() => import("layouts/caseClassification"));
const ProcessMining = lazy(() => import("layouts/processMining/processMining"));
const TreeBreakdown = lazy(() => import("layouts/treeBreakdown"));
const Support = lazy(() => import("layouts/support"));
const SupportDesk = lazy(() => import("layouts/support/SupportDesk"));

// Every role that can sign in to the platform can raise a support query.
export const ALL_PLATFORM_ROLES = [
  "agent1",
  "agent2",
  "admin",
  "superuser",
  "3PA",
  "3PL",
  "3PU",
];

// The support desk belongs to a single mailbox; the backend enforces this too.
export const SUPPORT_DESK_EMAILS = ["sparsh@neatprocess.com"];

export const defaultRoutes = [
  {
    type: "",
    name: "Profile",
    key: "profile",
    icon: <span class="material-symbols-outlined">account_box</span>,
    route: "/profile",
    path: "/profile",
    access: ["agent1", "admin", "agent2", "superuser", "3PA", "3PL", "3PU"],
    component: <Profile />,
    showChatbot: true,
  },
  {
    type: "collapse",
    name: "Analytics",
    key: "analytics",
    icon: <span class="material-symbols-outlined">bar_chart_4_bars</span>,
    route: "/analytics",
    path: "/analytics", // Using Default case id for developement
    access: ["agent1", "admin", "superuser", "agent2"],
    component: <Analytics />,
    showChatbot: true,
  },
  {
    type: "collapse",
    name: "Claims",
    key: "cases",
    icon: <span class="material-symbols-outlined">folder_open</span>,
    path: "/:agent_id/cases",
    access: ["agent1", "admin", "agent2", "superuser", "3PA", "3PL", "3PU"],
    component: <Tables />,
    showChatbot: true,
  },
  {
    type: "collapse",
    name: "User Management",
    key: "userManagement",
    icon: <span class="material-symbols-outlined">group</span>,
    route: "/admin/userManagement",
    path: "/admin/userManagement",
    access: ["superuser"],
    component: <UserManagement />,
    showChatbot: true,
  },
  {
    type: "collapse",
    name: "Bulk Case Upload",
    key: "bulk",
    icon: <span class="material-symbols-outlined">cloud_upload</span>,
    route: "/bulk",
    path: "/bulk",
    access: ["admin", "superuser"],
    component: <Bulk />,
    showChatbot: true,
  },
  {
    type: "",
    name: "Case",
    key: "case",
    icon: (
      <Icon fontSize="medium" className="navbar-icon">
        notifications
      </Icon>
    ),
    route: "/cases/case",
    path: "/cases/:case_id",
    access: ["agent1", "admin", "superuser", "agent2", "3PA", "3PL", "3PU"],
    component: <FormDetails />,
    showChatbot: true,
  },
  {
    type: "collapse",
    name: "Worflow Update",
    key: "workflowUpdate",
    icon: <span class="material-symbols-outlined">rebase_edit</span>,
    route: "/workflowUpdate",
    path: "/workflowUpdate",
    access: ["superuser"],
    component: <WorkflowUpdate />,
    showChatbot: true,
  },
  {
    type: "collapse",
    name: "Worflow View",
    key: "workflowview",
    icon: <span class="material-symbols-outlined">account_tree</span>,
    route: "/workflowview",
    path: "/workflowview",
    access: ["agent2", "superuser", "agent1", "admin", "3PA", "3PL", "3PU"],
    component: <WorkflowView />,
    showChatbot: true,
  },
  // {
  //   type: "collapse",
  //   name: "Chat Intel",
  //   key: "texttosql",
  //   icon: (
  //     <Icon fontSize="medium" className="navbar-icon">
  //       smart_toy_rounded
  //     </Icon>
  //   ),
  //   route: "/texttosql",
  //   path: "/texttosql",
  //   access: ["superuser"],
  //   component: <MainChat />,
  // },
  // {
  //   type: "collapse",
  //   name: "Tag Insights",
  //   key: "taginsights",
  //   icon: (
  //     <Icon fontSize="medium" className="navbar-icon">
  //       tags
  //     </Icon>
  //   ),
  //   route: "/taginsights",
  //   path: "/taginsights",
  //   access: ["superuser"],
  //   component: <TagInsights />,
  // },
  // {
  //   type: "collapse",
  //   name: "Case Classification",
  //   key: "caseclassification",
  //   icon: (
  //     <Icon fontSize="medium" className="navbar-icon">
  //       classify
  //     </Icon>
  //   ),
  //   route: "/caseclassification",
  //   path: "/caseclassification",
  //   access: ["superuser"],
  //   component: <CaseClassification />,
  // },
  // {
  //   type: "collapse",
  //   name: "Visual Breakdown",
  //   key: "visualBreakdown",
  //   icon: (
  //     <Icon fontSize="medium" className="navbar-icon">
  //       account_tree
  //     </Icon>
  //   ),
  //   route: "/visualBreakdown",
  //   path: "/visualBreakdown",
  //   access: ["superuser"],
  //   component: <TreeBreakdown />,
  // },
  // {
  //   type: "collapse",
  //   name: "Process Mining",
  //   key: "processMining",
  //   icon: (
  //     <Icon fontSize="medium" className="navbar-icon">
  //       analytics
  //     </Icon>
  //   ),
  //   route: "/processMining",
  //   path: "/processMining",
  //   access: ["superuser"],
  //   component: <ProcessMining />,
  // },
  {
    type: "collapse",
    name: "Help & Support",
    key: "support",
    icon: <span class="material-symbols-outlined">support_agent</span>,
    route: "/support",
    path: "/support",
    access: ALL_PLATFORM_ROLES,
    component: <Support />,
    showChatbot: true,
  },
  {
    type: "collapse",
    name: "Support Desk",
    key: "supportDesk",
    icon: <span class="material-symbols-outlined">inbox_customize</span>,
    route: "/support/desk",
    path: "/support/desk",
    access: ALL_PLATFORM_ROLES,
    allowedEmails: SUPPORT_DESK_EMAILS,
    component: <SupportDesk />,
    showChatbot: true,
  },
  {
    type: "",
    name: "Logout",
    key: "access-denied",
    icon: <span class="material-symbols-outlined">logout</span>,
    route: "/auth2/logout",
    path: "/auth2/logout",
    access: ["agent2", "superuser", "agent1", "admin", "3PA", "3PL", "3PU"],

    component: <Logout />,
  },
  {
    type: "",
    name: "Access Denied",
    key: "access-denied",
    icon: (
      <Icon fontSize="medium" className="navbar-icon">
        assignment
      </Icon>
    ),
    route: "/access-denied",
    path: "/access-denied",
    access: ["agent2", "superuser", "agent1", "admin", "3PA", "3PL", "3PU"],

    component: <AccessDenied />,
  },
];
